if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

//tabs sections
const tabLinks = document.querySelectorAll('ul.tabs__menu li a');

for (let i = 0; i < tabLinks.length; i++) {
    tabLinks[i].onclick = function() {
        let target = this.getAttribute('href').replace('#', '');
        let sections = document.querySelectorAll('div.tab-content');
        for(let j=0; j < sections.length; j++) {
            sections[j].style.display = 'none';
        }
        document.getElementById(target).style.display = 'block';
        for(let k=0; k < tabLinks.length; k++) {
            tabLinks[k].removeAttribute('class');
        }
        this.setAttribute('class', 'active');
        return false;
    }
}

(function(){

    function scrollDown(){
        let top = $(document).scrollTop();
        if (top > 0) {
            $('header').addClass('scroll');
        } else {
            $('header').removeClass('scroll');
        }

        if (top > $('.hero-container').outerHeight()-91) {
            $('.submenu-container').addClass('scroll');
        } else {
            $('.submenu-container').removeClass('scroll');
        }
    }

    //Acts when scroll down page.
    $(window).scroll(function (event) {
        scrollDown();
    });

    //HOME ARROW
    $('.arrow-home').click(function(event) {
        $('body, html').animate({
            scrollTop: $('.hero-container').outerHeight() - 200
        });
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    

    $('.sym-slides').slick();

    $('.expand-content').click(function() {
        event.preventDefault();
        $(this).next().slideDown();
    });

    $('.closemore').click(function() {
        event.preventDefault();
        $(this).parent().slideUp();
    });

    //$('.filter-holder select').select2();

    $('.fancybox-copy').fancybox({
        wrapCSS : 'fancybox-copy-holder'
    });

    $('.easy-scroll').click(function () {
        var target = $(this).attr("href");
        if ($('body.main').length > 0) { var padding = 0; } else { var padding = ($('header').height() + 15) * 3; }
        $('html, body').animate({ scrollTop: $(target).offset().top - padding }, 1500);
        console.log(padding);
        return false;

    });

//    $('.sub-menu a[href*=\\#]:not([href=\\#])').click(function() {
//        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//            var target = $(this.hash);
//            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//            if (target.length) {
//                $('html,body').animate({
//                    scrollTop: target.offset().top - 200
//                }, 1000);
//                return false;
//            }
//        }
//    });

})();

